import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { GameState, GameStatus, EMOJI_SETS, ADV_ROUND } from '@utils/game/tileConnect/constants.js';
import { findPath, checkAnyMoves, shuffleGrid } from '@utils/game/tileConnect/gameLogic.js';
import { audioService } from '@utils/game/tileConnect/audioService.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
import LinkBoard from "../../components/game/tileConnect/linkBoard.vue";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "tileConnectPage",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    nextBtnText() {
      return (this.gameState.level + 1) % ADV_ROUND === 0 ? this.$lang('Continue (Ad)') : this.$lang('Next Level');
    },
    currentIconSet() {
      return EMOJI_SETS[(this.gameState.level - 1) % EMOJI_SETS.length];
    }
  },
  data() {
    return {
      gameState: {
        ...GameState
      },
      GameStatus,
      revives: 10,
      maxRevives: 10,
      lastScore: 0,
      timeVal: null,
      timer: null,
      stimeVal: null,
      leftTime: 0,
      prizePool: 0,
      timePeriod: "",
      userReward: null,
      popUserRewardShow: false,
      popGameRankShow: false,
      popStartShow: false,
      popLostShow: false,
      popWinShow: false,
      popOpenMobileShow: false,
      totalScore: 0,
      grid: []
    };
  },
  watch: {
    'gameState.status': {
      handler() {
        clearTimeout(this.timeVal);
        if (this.gameState.status === GameStatus.LOST) {
          this.popLostShow = true;
        } else if (this.gameState.status === GameStatus.WON) {
          this.popWinShow = true;
        } else if (this.gameState.status === GameStatus.MENU) {
          this.popStartShow = true;
        } else if (this.gameState.status === GameStatus.PLAYING) {
          this.popStartShow = false;
          this.popWinShow = false;
          this.popLostShow = false;
          this.handleTimer();
        }
      }
    },
    'totalScore': {
      handler() {
        clearTimeout(this.timeVal);
        this.timeVal = setTimeout(() => {
          this.end();
        }, 200);
      }
    },
    "popGameRankShow": {
      handler(newVal, oldVal) {
        if (newVal) {
          clearTimeout(this.timer);
        } else {
          this.handleTimer();
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.timer);
      clearTimeout(this.timeVal);
      clearTimeout(this.stimeVal);
      this.end();
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    playSelect() {
      audioService.playSelect();
    },
    playMatch() {
      audioService.playMatch();
    },
    playFail() {
      audioService.playFail();
    },
    playLevelUp() {
      audioService.playLevelUp();
    },
    startGame(nextLevel = 1) {
      const callback = async res => {
        await this.start();
        // 1. Calculate Grid Size based on level milestones
        let innerRows = 6;
        let innerCols = 6;
        if (nextLevel >= 16) {
          innerRows = 12;
          innerCols = 7;
        }
        if (nextLevel >= 12) {
          innerRows = 10;
          innerCols = 7;
        } else if (nextLevel >= 8) {
          innerRows = 8;
          innerCols = 6;
        } else if (nextLevel >= 4) {
          innerRows = 7;
          innerCols = 6;
        }
        const rows = innerRows + 2;
        const cols = innerCols + 2;

        // 2. Difficulty Multiplier (5% per level)
        // Time decreases by 5% each level
        const timeFactor = 6 * (nextLevel - 1);
        const newTimeLimit = Math.max(50, Math.floor(this.gameState.timeLimit - timeFactor));

        // 3. Icon Variety
        const currentEmojiSet = EMOJI_SETS[(nextLevel - 1) % EMOJI_SETS.length];
        // Start with 6 types, increase as level goes up
        const typesToUse = Math.min(currentEmojiSet.length, 6 + Math.floor((nextLevel - 1) / 2));
        const totalInnerTiles = innerRows * innerCols;
        const types = [];
        for (let i = 0; i < totalInnerTiles / 2; i++) {
          const type = Math.floor(Math.random() * typesToUse);
          types.push(type, type);
        }

        // Shuffle types
        for (let i = types.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [types[i], types[j]] = [types[j], types[i]];
        }
        const newGrid = [];
        let typeIdx = 0;
        for (let y = 0; y < rows; y++) {
          const row = [];
          for (let x = 0; x < cols; x++) {
            const isInner = x > 0 && x < cols - 1 && y > 0 && y < rows - 1;
            row.push({
              id: `${x}-${y}`,
              type: isInner ? types[typeIdx++] : -1,
              pos: {
                x,
                y
              },
              isVisible: isInner
            });
          }
          newGrid.push(row);
        }
        this.grid = newGrid;
        this.gameState.score = 0;
        if (nextLevel === 1) {
          this.totalScore = 0;
          this.revives = this.maxRevives;
        }
        this.gameState.timeLeft = newTimeLimit;
        this.gameState.status = GameStatus.PLAYING;
        this.gameState.selectedTile = null;
        this.gameState.hintPath = null;
        this.gameState.lastConnection = null;
        this.gameState.level = nextLevel;
        this.gameState.hintCount = 3;
        this.gameState.shuffleCount = 3;
      };
      try {
        if (nextLevel % ADV_ROUND === 0) {
          let advData = getRandomElement(this.advList);
          if (advData) {
            gameAdv.show(advData, this.timePeriod, res => {
              callback(res);
            }, this);
          } else {
            callback(null);
          }
        } else {
          callback(null);
        }
      } catch (error) {
        callback(null);
      }
    },
    handleTileClick(tile) {
      if (this.gameState.status !== GameStatus.PLAYING) return;
      if (!tile.isVisible) return;
      this.playSelect();
      if (!this.gameState.selectedTile) {
        this.gameState.selectedTile = tile;
        return;
      }
      if (this.gameState.selectedTile.id === tile.id) {
        this.gameState.selectedTile = null;
        return;
      }
      if (this.gameState.selectedTile.type === tile.type) {
        const path = findPath(this.gameState.selectedTile.pos, tile.pos, this.grid);
        if (path) {
          this.gameState.lastConnection = path;
          const newGrid = [...this.grid];
          newGrid[this.gameState.selectedTile.pos.y][this.gameState.selectedTile.pos.x].isVisible = false;
          newGrid[tile.pos.y][tile.pos.x].isVisible = false;
          this.grid = newGrid;
          this.gameState.score += 10;
          this.totalScore += 10;
          this.gameState.selectedTile = null;
          this.gameState.hintPath = null;
          this.playMatch();
          if (newGrid.flat().every(t => !t.isVisible || t.type === -1)) {
            // Time bonus scaled by 5% difficulty per level
            const bonus = Math.floor(this.gameState.timeLeft * 10 * (1 + (this.gameState.level - 1) * 0.05));
            this.gameState.timeBonus = bonus;
            this.gameState.score += bonus;
            this.totalScore += bonus;
            this.gameState.status = GameStatus.WON;
            this.playLevelUp();
          } else {
            if (!checkAnyMoves(newGrid)) {
              setTimeout(() => {
                this.grid = shuffleGrid(newGrid);
              }, 500);
            }
          }
          return;
        }
      }
      this.gameState.selectedTile = tile;
    },
    useHint() {
      if (this.gameState.hintCount <= 0 || this.gameState.status !== GameStatus.PLAYING) return;
      const move = checkAnyMoves(this.grid);
      if (move) {
        this.gameState.hintPath = [move.p1, move.p2];
        this.gameState.hintCount--;
        setTimeout(() => this.gameState.hintPath = null, 1500);
      }
    },
    useShuffle() {
      if (this.gameState.shuffleCount <= 0 || this.gameState.status !== GameStatus.PLAYING) return;
      this.grid = shuffleGrid(this.grid);
      this.gameState.shuffleCount--;
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "tileConnect"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
      });
    },
    async end() {
      if (this.lastScore >= this.totalScore) return;
      this.lastScore = this.gameState.score;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "tileConnect",
        level: 1,
        score: this.totalScore,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "tileConnect"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.userReward = rs.data.userReward ?? null;
        this.lastScore = rs.data.score ?? 0;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    async handleTimer() {
      // 避免重复创建计时器
      clearTimeout(this.timer);
      this.gameState.timeLeft = this.gameState.timeLeft - 1;
      this.$nextTick(() => {
        if (this.gameState.timeLeft <= 0) {
          this.popLostShow = true;
          this.playFail();
          this.gameState.status = GameStatus.LOST;
        } else {
          this.timer = setTimeout(() => {
            this.handleTimer();
          }, 1000);
        }
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(async () => {
        if (this.leftTime <= 0) {
          await this.init();
          this.gameState.status = GameStatus.MENU;
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    handleRevive() {
      const callback = res => {
        this.revives--;
        this.gameState.timeLeft = 40;
        this.gameState.status = GameStatus.PLAYING;
      };
      try {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } catch (error) {
        callback(null);
      }
    },
    handleCancel() {
      this.popLostShow = false;
      this.popStartShow = true;
    },
    handleConfirm() {
      this.revives > 0 ? this.handleRevive() : this.handleCancel();
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "tileConnect"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.end();
        this.popGameRankShow = true;
      });
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    this.gameState.status = GameStatus.MENU;
  }
};